module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"messages":{}},"ja":{"messages":{}}}')
  delete Component.options._Ctor
}
